import type { AppEnvironment } from './types';
import { ESTATE_PAGE_COPY } from './page-copy-estate';

/**
 * IP4x stack scoped to a fixed root tenant for Core SSO. Use when the
 * vertical operates as a hub serving multiple child estates that should
 * share login. `rootTenantId` is the SSO scope boundary.
 */
export const env: AppEnvironment = {
  production: true,
  buildMode: 'ip4x-root',
  apiBaseUrl: 'https://ip4x-za.sudosky.com/v1',
  coreApiUrl: 'https://ip4x-core-api.sudosky.com/v1',
  appTemplateId: '',
  authMode: 'core',
  portalOwnerType: 'member',
  loadDomainConfig: true,
  defaultDomain: '',
  rootTenantId: 'd1bb2a75-f0c8-4d28-9a81-c4e8a090efae',
  portalBaseUrl: 'https://member.ip4x.systems',
  appName: 'IP4x Member Portal',
  version: '1.0.0',
  appShell: 'classic',
  welcomeContent: {
    eyebrow: 'Resident companion',
    title: 'The estate,\nin your pocket.',
    subtitle: 'Access and estate services in one place.',
  },
  communitySelectContent: {
    title: 'Choose your community',
    subtitle: 'Search for your estate or complex to continue.',
  },
  signupTermsUrl: 'https://www.ip4estates.com/terms',
  pageCopy: ESTATE_PAGE_COPY,
};
